module.exports = __webpack_public_path__ + "static/media/anim.8f8886f7.svg";